// extracted by mini-css-extract-plugin
module.exports = {"finance":"Finance_finance__24cAn","tabs":"Finance_tabs__3TVqF","tabsContainer":"Finance_tabsContainer__3hyng","templateContent":"Finance_templateContent__3kFAv"};